<app-service-detail>
    <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="row w-100 m-0 position-relative">

        <app-list-grid *ngIf="!hideList"
                    class="col-md-12 px-md-5 ml-auto"
                    [items]="documentResults"
                    [determinantMapById]="determinantMapById"
                    [toggleIcons]="false"
                    [navigationEdit]="false"
                    [expanded]="true"
                    (deleteFunction)="deleteDocumentResult($event)"
                    (editFunction)="loadResult($event)"
                    (sortFunction)="sortNotification($event)"
                    headingText="Results available in the service"
                    [elementsNumber]="elementsNumber"
                    createNewText1Part="Select existing result or click on"
                    createNewText2Part="to create a new result">
            <button (click)="loadResult(false)"
                placement="left" aria-hidden="true"
                class="btn btn-sm btn-primary mr-1">{{ 'Add' | translate }}</button>
        </app-list-grid>

        <div *ngIf="showEdit || showAdd"
                class="layer half-layer col px-3"
                [ngStyle]="style" mwlResizable
                [enableGhostResize]="true"
                [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
                (resizeEnd)="onResizeEnd($event)"
                style="min-height:calc(100vh - 9.1rem);">
                <div class="moving">
                    <document-result-edit
                        [serviceId]="serviceId"
                        [documentResult]="result"
                        (formSubmit)="closeSlider()"
                        (editCancel)="closeLayers()"
                        class="w-100"></document-result-edit>
                </div>
        </div>
        <div class="shadow"></div>
        <div class="col">
            <tab-menu *ngIf="hideList"
                [items]="documentResults">
            </tab-menu>
            <ng-content></ng-content>
        </div>
    </div>
</app-service-detail>
